import { render, staticRenderFns } from "./pgd-andamento.vue?vue&type=template&id=49b3a374&scoped=true"
import script from "./pgd-andamento.vue?vue&type=script&lang=js"
export * from "./pgd-andamento.vue?vue&type=script&lang=js"
import style0 from "./pgd-andamento.vue?vue&type=style&index=0&id=49b3a374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3a374",
  null
  
)

export default component.exports